import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";

import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
  selector: "hawk-ticket-form",
  templateUrl: "./dashboard-customer.component.html",
  //styleUrls: ['./dashboard-customer.component.scss'],
  imports: [NgSelectModule, FormsModule, ReactiveFormsModule, RouterModule, FontAwesomeModule, FormsModule],
  host: {
    class: "app-page",
  },
})
export class DashboardCustomerComponent {}
